module.exports = __webpack_public_path__ + "img/vote-2@2x.765ea3e3.png";